import React from 'react';
import Tag from '@common/Tag';

const LessonPlanCard = ({ name, description, tags = [] }) => {
    return (
        <div className="ch-lesson-plan-card">
            <div className="ch-lesson-plan-card-header">
                <span className="ch-lesson-plan-card-name">{name}</span>
            </div>
            {description && (
                <p className="ch-lesson-plan-card-description">{description}</p>
            )}
            {tags.length > 0 && (
                <div className="ch-lesson-plan-card-tags">
                    {tags.map(tag => (
                        <Tag key={tag}>{tag}</Tag>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LessonPlanCard;
